const staticPages =
  [
    {
      url: '/page/about-company',
      name: {
        en: 'About Company',
        ka: 'კომპანიის შესახებ'
      }
    },
    {
      url: '/media',
      name: {
        en: 'Media',
        ka: 'მედია'
      }
    },
    {
      url: '/about-us/mall-map',
      name: {
        en: 'Mall Map',
        ka: 'მოლის რუქა'
      }
    },
    {
      url: '/page/career',
      name: {
        en: 'Career',
        ka: 'კარიერა'
      }
    },
    {
      url: '/page/how-to-get',
      name: {
        en: 'How to Get',
        ka: 'როგორ მივიდეთ'
      }
    },
    {
      url: '/page/contact',
      name: {
        en: 'Contact',
        ka: 'კონტაქტი'
      }
    }
  ]
export default staticPages
